import React from 'react';

const ValidationBanner = ({rejectReasons}) => {
  return (
    <div className='stepper-warning-message '>
      {rejectReasons.case === "thirdPartyValidations" && 
        <>
          <div className="invalid-modal__body">
            <h4>Η αίτησή σας απορρίφθηκε, καθώς:</h4>
            <ul>
            {!rejectReasons.isGreekAfm && <li>δεν είναι Ελληνικό Α.Φ.Μ.</li> }
            {!rejectReasons.isActive && <li><p>δεν είναι ενεργή κατά την ημερομηνία υποβολής της αίτησης Χρηματοδότησης από το Πρόγραμμα.</p></li> }
            {rejectReasons.responseCode === "901" && <li><p>υπάρχει ήδη ενεργή αίτηση με αυτό το ΑΦΜ.</p></li>}
            {rejectReasons.responseCode === "902" && <li><p>έχετε ήδη λάβει επιδότηση μέσω της δράσης Super-FastBroadband (SFBB).</p></li>}
            {rejectReasons.responseCode === "903" && <li><p>το αίτημα δεν είναι αποδεκτό λόγω μη επιλέξιμου ΚΑΔ.</p></li>}
            {rejectReasons.responseCode === "904" && <li><p>ο ΑΦΜ έχει υπερβεί το όριο κρατικών ενισχύσεων μέσω του προγράμματος «Smart Readiness»</p></li>}
            </ul>
          </div>
        </>
      }
      </div>
  );
};

export default ValidationBanner;
